// 五子棋策略提示配置
// 可用的样式标签：
// 粗体：<strong>文字</strong>
// 红色：<span style="color: red;">文字</span>
// 蓝色：<span style="color: blue;">文字</span>
// 绿色：<span style="color: green;">文字</span>
// 斜体：<em>文字</em>
// 下划线：<u>文字</u>
// 组合使用：<strong><span style="color: red;">重要红色文字</span></strong>

export const strategyTips = {
    // 获胜路线分析
    winningPattern: {
        title: '01-获胜路线分析',
        defaultCollapsed: false,
        sections: [
            {
                title: '最终获胜模式',
                numbered: true,
                content: [
                    '黑棋获胜最后一步一定是<span style="color: red;">四三</span>（冲四+活三）',
                    '获胜倒数第二步一定是形成<span style="color: red;">四三前一手</span>的同时 <span style="color: red;">一子双(多)杀</span>（不考虑活三，四三前，VCF前等VC3不防特殊情况）',
                    'VCF算最后一步的话，VCF前一手也是一子双(多)杀(<span style="color: red;">多个VC3</span>), 一个点形成多个VCF不能全部拦住也算一子双杀'
                ]
            },
            {
                title: '四三前一手(一子双杀)',
                numbered: true,
                content: [
                    '<span style="color: red;">眠三+活二</span>，并且有其他路线上的VC3形成一子双(多)杀',
                    '黑棋获胜一定要有<span style="color: red;">眠三</span>'
                ]
            },
            {
                title: '四三前两手(四三前一手的前一手)',
                numbered: true,
                content: [
                    '<span style="color: red;">眠三+活一(VC2)</span>， 下一手一子双(多)杀，VC3的同时形成四三前',
                    '<span style="color: red;">眠二+活二(VC2)</span>， 下一手一子双(多)杀，VC3的同时形成四三前',
                    '<span style="color: red;">活二+活二(VC2,少数)</span>， 下一手眠三形成四三前和其他线路上的VC3一子双(多)杀',
                    '双(多)眠三形成VCF前， 下出四三前的同时其他路线上的VC3'
                ]
            },
            {
                title: 'VCN定义',
                numbered: true,
                content: [
                    '<strong>VC4(VCF)</strong>: 直接连续冲四最终形成连五，直接获胜',
                    '<strong>VC3(VCT)</strong>: 这一步不拦或者多个点拦不住，下一步形成VC4。活三，四三前一手，VCF前都是VC3',
                    '<strong>VC2</strong>: 这一步不拦，下一步可以形成VC3。活二是VC2，注意一子通多路'
                ]
            }
        ]
    },

    // n步胜策略
    nStepStrategy: {
        title: '02-N步胜策略',
        defaultCollapsed: false,
        sections: [
            {
                title: '分析步骤',
                numbered: true, // 标记为需要编号的步骤
                content: [
                    '找自己的<span style="color: red;">眠三、活二</span>',
                    '找对方的<span style="color: red;">眠三、活二</span>(考虑防守点，被反的可能)',
                    '获胜前一步是一子双杀，通过连续VCT把不同区域的眠三、活二和进攻路线新形成的眠三活二连接起来做一子双杀',
                    '比较难发现的题,先把眠三冲四冲掉, 先不管被反的情况,寻找获胜路线的连接线路',
                    '找眠三的四三前的点，根据连接路线寻找<span style="color: red;">一子通多路</span>的点',
                    '重排顺序，最后一步做四三，前面一步做一子双杀',
                    '如果缺少眠三，找一下眠二活二的VC2，考虑VC3同时制造眠三，下一步再根据上面的分析',
                    '注意禁手点'
                ]
            },
            {
                title: '第一手要求',
                numbered: true,
                content: [
                    '一定要<span style="color: red;">VC3</span>（活三，四三前一手，VCF前一手）',
                    '要形成<span style="color: red;">一子通多路</span>，便于下一步进攻',
                    'VC3的同时形成VC3就是一子双(多)杀',
                    '还没有一子双(多)杀的情况，VC3的同时形成VC2(眠三、活二或四三前两手)',
                    '特殊的VC3: 双眠三形成VCF前',
                ]
            },
            {
                title: '第二手开始',
                numbered: true,
                content: [
                    '前一手有双(多)杀，还剩一个VC3没防住，但是有反四。形成VC3的同时要么解除反四，要么把反活四降级为反冲四，被反时再反回来',
                    '其他情况后面的每一步要先看<span style="color: red;">分析步骤</span>,再看<span style="color: red;">第一手要求</span>，直到出现一子多杀对方防不住'
                ]
            },
            {
                title: '倒数第二手',
                numbered: true,
                content: [
                    '<span style="color: red;">一子(双)多杀</span>，不能全防住'
                ]
            }
        ]
    },

    // 防守与反击
    defenseCounter: {
        title: '03-防守与反击',
        defaultCollapsed: false,
        sections: [
            {
                title: '应对策略',
                numbered: true,
                content: [
                    '有被<strong>反三、反四</strong>情况时，考虑交换顺序，这样被反的时候自己的VC等级更高，可以无视',
                    'VCF被反四时，考虑另一个冲四点，或者挡住对方反四线路的进攻，做双杀',
                    '反活四可以提前<strong>VC3</strong>或<strong>冲四</strong>挡住对方，反四降级为反冲四，冲四再反回来',
                    '同样，反活三可以提前阻挡降级为反眠三，进而可以继续VC3进攻，或者反VC3反回来',
                    '如果对方反VC3，要么反回来，将对方降级到VC2,可以继续VC3进攻，如果反不回来，那就只剩下VC4(VCF)获胜了'
                ]
            },
            {
                title: '禁手处理',
                numbered: true,
                content: [
                    '获胜路线中有<strong>四四禁手</strong>考虑<strong>长连解禁</strong>，或者少进攻一路，四四变四三'
                ]
            }
        ]
    }
}

// 威胁等级说明
export const threatLevelInfo = {
    title: '威胁等级详细说明',
    levels: [
        {
            category: '定胜负级别（红色）',
            items: [
                { level: 'A', desc: '五连：已形成五子连线，游戏结束' },
                { level: 'B', desc: '活四：下一步必胜，对手无法防守' }
            ]
        },
        {
            category: '高危险级别（深橙色）',
            items: [
                { level: 'C', desc: '冲四活三：同时具有冲四和活三，形成双重威胁' },
                { level: 'D', desc: '冲四+：强制性冲四配合其他威胁，压迫性极强' },
                { level: 'E', desc: '冲四：单一冲四威胁，对手必须防守' }
            ]
        },
        {
            category: '警戒级别（橙黄色）',
            items: [
                { level: 'F', desc: '双活三：两个活三威胁，几乎等同必胜' },
                { level: 'G', desc: '活三+：活三配合其他威胁形成组合攻击' },
                { level: 'H', desc: '活三：单一活三威胁，可发展为活四' }
            ]
        },
        {
            category: '较低危险级别（灰色）',
            items: [
                { level: 'I', desc: '冲三活二：冲三配合活二的组合威胁' },
                { level: 'J', desc: '双活二：两个活二威胁，可发展为活三' },
                { level: 'K', desc: '冲三：单一冲三威胁，一端被堵住' },
                { level: 'L', desc: '活二：单一活二威胁，两端都可延伸' }
            ]
        },
        {
            category: '特殊标记',
            items: [
                { level: 'FORBID', desc: '禁手点（连珠规则下的违规位置）' },
                { level: 'NONE', desc: '无威胁点（普通落子点）' }
            ]
        }
    ]
} 